import Axes from '../../sceneWrapper/types/Axes';

/** The current position of the pointer. */
const pointerPos: Pick<Axes, 'x' | 'y'> = {
    x: Math.round(window.innerWidth / 2),
    y: Math.round(window.innerHeight / 2)
};

export default pointerPos;
